/**
 * Composition Root — einzige Stelle für konkrete Infrastructure-Instanzen (ADR-0009).
 */

import { StorageEngine } from '../../infrastructure/storage/StorageEngine';
import { KvSalesRepository } from '../../infrastructure/repositories/KvSalesRepository';
import { KvSessionsRepository } from '../../infrastructure/repositories/KvSessionsRepository';
import { KvPurchasesRepository } from '../../infrastructure/repositories/KvPurchasesRepository';
import { KvInvoicesRepository } from '../../infrastructure/repositories/KvInvoicesRepository';
import { KvBusinessPayloadRepository } from '../../infrastructure/repositories/KvBusinessPayloadRepository';
import { KvCashRegisterRepository } from '../../infrastructure/repositories/KvCashRegisterRepository';
import { KvCustomersRepository } from '../../infrastructure/repositories/KvCustomersRepository';
import { KvProductsRepository } from '../../infrastructure/repositories/KvProductsRepository';
import { KvSuppliersRepository } from '../../infrastructure/repositories/KvSuppliersRepository';
import { KvOrdersRepository } from '../../infrastructure/repositories/KvOrdersRepository';
import {
  setStorageEngineRef,
  clearStorageEngineRef
} from '../../infrastructure/storage/storageEngineRef';

let storageEngineInstance = null;
let salesRepositoryInstance = null;
let sessionsRepositoryInstance = null;
let purchasesRepositoryInstance = null;
let invoicesRepositoryInstance = null;
let businessPayloadRepositoryInstance = null;
let cashRegisterRepositoryInstance = null;
let customersRepositoryInstance = null;
let productsRepositoryInstance = null;
let suppliersRepositoryInstance = null;
let ordersRepositoryInstance = null;

/**
 * Verdrahtet die Engine (Phase 0: localStorage, Phase 1: IndexedDbKvBackend).
 * @param {{ kvBackend?: object, sessionBackend?: object }} [options]
 */
export function configureStorageEngine(options = {}) {
  storageEngineInstance = new StorageEngine(options.kvBackend, options.sessionBackend);
  setStorageEngineRef(storageEngineInstance);
  return storageEngineInstance;
}

export function getStorageEngine() {
  if (!storageEngineInstance) {
    storageEngineInstance = new StorageEngine();
    setStorageEngineRef(storageEngineInstance);
  }
  return storageEngineInstance;
}

/** @returns {KvSalesRepository} */
export function getSalesRepository() {
  if (!salesRepositoryInstance) {
    salesRepositoryInstance = new KvSalesRepository();
  }
  return salesRepositoryInstance;
}

/** @returns {KvSessionsRepository} */
export function getSessionsRepository() {
  if (!sessionsRepositoryInstance) {
    sessionsRepositoryInstance = new KvSessionsRepository();
  }
  return sessionsRepositoryInstance;
}

/** @returns {KvPurchasesRepository} */
export function getPurchasesRepository() {
  if (!purchasesRepositoryInstance) {
    purchasesRepositoryInstance = new KvPurchasesRepository();
  }
  return purchasesRepositoryInstance;
}

/** @returns {KvInvoicesRepository} */
export function getInvoicesRepository() {
  if (!invoicesRepositoryInstance) {
    invoicesRepositoryInstance = new KvInvoicesRepository();
  }
  return invoicesRepositoryInstance;
}

/** @returns {KvBusinessPayloadRepository} */
export function getBusinessPayloadRepository() {
  if (!businessPayloadRepositoryInstance) {
    businessPayloadRepositoryInstance = new KvBusinessPayloadRepository();
  }
  return businessPayloadRepositoryInstance;
}

/** @returns {KvCashRegisterRepository} */
export function getCashRegisterRepository() {
  if (!cashRegisterRepositoryInstance) {
    cashRegisterRepositoryInstance = new KvCashRegisterRepository();
  }
  return cashRegisterRepositoryInstance;
}

/** @returns {KvCustomersRepository} */
export function getCustomersRepository() {
  if (!customersRepositoryInstance) {
    customersRepositoryInstance = new KvCustomersRepository();
  }
  return customersRepositoryInstance;
}

/** @returns {KvProductsRepository} */
export function getProductsRepository() {
  if (!productsRepositoryInstance) {
    productsRepositoryInstance = new KvProductsRepository();
  }
  return productsRepositoryInstance;
}

/** @returns {KvSuppliersRepository} */
export function getSuppliersRepository() {
  if (!suppliersRepositoryInstance) {
    suppliersRepositoryInstance = new KvSuppliersRepository();
  }
  return suppliersRepositoryInstance;
}

/** @returns {KvOrdersRepository} */
export function getOrdersRepository() {
  if (!ordersRepositoryInstance) {
    ordersRepositoryInstance = new KvOrdersRepository();
  }
  return ordersRepositoryInstance;
}

export {
  listSalesForBusiness,
  listPurchasesForBusiness,
  listLotsForBusiness,
  listCustomersForBusiness,
  listProductsForBusiness
} from '../../application/read/businessAggregateRead';

/** Für Tests: Engine + Repositories zurücksetzen */
export function __resetStorageEngineForTests() {
  storageEngineInstance = null;
  clearStorageEngineRef();
  salesRepositoryInstance = null;
  sessionsRepositoryInstance = null;
  purchasesRepositoryInstance = null;
  invoicesRepositoryInstance = null;
  businessPayloadRepositoryInstance = null;
  cashRegisterRepositoryInstance = null;
  customersRepositoryInstance = null;
  productsRepositoryInstance = null;
  suppliersRepositoryInstance = null;
  ordersRepositoryInstance = null;
}
